import type {ReactElement} from 'react';
import React, {useState, useEffect} from 'react';
import styles from './design-seek-item-background-container.module.scss';

interface DesignSeekItemBackgroundContainerProps {
  pageId: string;
}

export function DesignSeekItemBackgroundContainer({...props}: DesignSeekItemBackgroundContainerProps): ReactElement {
  const [srcForPoster, setSrcForPoster] = useState<string>('');
  const getSrcForPoster = (): string => {
    const fabricCanvas = window.posterEditor?.whiteboard?.pages.pagesHashMap[props.pageId].fabricCanvas;

    if (!fabricCanvas) {
      return '';
    }

    return fabricCanvas.toDataURL();
  };

  useEffect(() => {
    setSrcForPoster(getSrcForPoster());

    const intervalId = setInterval(() => {
      setSrcForPoster(getSrcForPoster());
    }, 4000);

    return (): void => {
      clearInterval(intervalId);
    };
  }, []);

  const getBackgroundImage = (): string | undefined => {
    return `url(${srcForPoster})`;
  };

  return (
    <div
      style={{
        backgroundImage: getBackgroundImage(),
      }}
      className={`${styles.container} _full-width _full-height radius-8`}
    />
  );
}
